module.exports = __webpack_public_path__ + "img/supportIcon_Inactive.3092cb22.png";